import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { PaginationRechercheLink, PaginationTagsLink } from '../../../components/ui/paginationLink/PaginationLink'

import Pagination from 'rsuite/Pagination'

import { CombiningTagsAndSearchList } from '../../../store/tags/tagsTyping'

import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'
import { fetchSearchList, fetchTagsList } from '../../../store/tags/tagsSlice'
import './paginationTagsAndSearch.sass'
import '../tags.sass'

interface Props {
    list: CombiningTagsAndSearchList[]
    total: number
}

const PaginationTagsAndSearch: React.FunctionComponent<Props> = ({ list, total }: Props) => {
    const location = useLocation()
    const dispatch = useDispatch()

    const getCurrentPage = () => new URLSearchParams(location.search).get('p')
    const [currentPage, setCurrentPage] = useState(getCurrentPage() || 1)
    const isTagsPage = location.pathname.includes('liste-de-mots-cles')

    useEffect(() => {
        setCurrentPage(getCurrentPage())
    }, [location.search])

    //@ts-ignore
    const PaginationTopBottom = (top) => (
        <div className={top ? 'paginationWrapper topPagination' : 'paginationWrapper'}>
            <Pagination
                limit={300}
                limitOptions={[20]}
                maxButtons={5}
                activePage={+currentPage}
                linkAs={isTagsPage ? PaginationTagsLink : PaginationRechercheLink}
                onChangePage={(page: number) => {
                    setCurrentPage(page)
                    isTagsPage
                        ? dispatch(fetchTagsList({ order: '', p: page }))
                        : dispatch(fetchSearchList({ p: page }))
                }}
                total={total}
            />
        </div>
    )

    return (
        <>
            <PaginationTopBottom top={true} />
            <div className="list">
                {list.map((item) => (
                    <a key={item.id} href={createLocalizedPath(paths.search.toPath({ tag: item.slug }))}>
                        <label>{isTagsPage ? item.text : item.request || ''}</label> (
                        {isTagsPage ? item.count : item.request_count})
                    </a>
                ))}
            </div>
            <PaginationTopBottom top={false} />
        </>
    )
}

export default PaginationTagsAndSearch
